import comp from "./FeedbackTable";
export default comp;
